// extracted by mini-css-extract-plugin
export default {"gdprBanner":"GDPRBanner_gdprBanner__dCFAl","gdprBannerOpen":"GDPRBanner_gdprBannerOpen__aiNmr"};